import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { TableColumnBaseEditorComponent } from './../base/base-editor.component';

@Component({
  selector: 'table-column-select-dropdown-editor',
  templateUrl: './select-dropdown-editor.component.tpl.html'
})
export class TableColumnSelectDropdownEditorComponent extends TableColumnBaseEditorComponent {

  public editDropdownValueId: string;
  public editDropdownValueLabel: string;
  public editDropdownOptionsArray: any[];
  public editDropdownMultiple: boolean;
  @Output() public selectClosedEvent: EventEmitter<any> = new EventEmitter<any>();


  constructor(injector: Injector) {
    super(injector);
  }

  agInit(params: any): void {
    super.agInit(params);
    this.editDropdownValueId = this.params.column.colDef.editDropdownValueId;
    this.editDropdownValueLabel = this.params.column.colDef.editDropdownValueLabel;
    this.editDropdownOptionsArray = this.params.column.colDef.editDropdownOptionsArray;
    this.editDropdownMultiple = this.params.column.colDef.editDropdownMultiple;
    if(this.editDropdownMultiple) {
      this.initializeSelectedValues();
    }
  }

  initializeSelectedValues(): void {
    if (this.params.value) {
      // If the saved value is an array (for multi-select)
      if (Array.isArray(this.params.value)) {
        this.params.value = this.params.value.filter((savedValue) => {
          // Match the saved value ids with the available options
          return this.editDropdownOptionsArray.some((option) => option[this.editDropdownValueId] === savedValue);
        });
      } else {
        // If the saved value is a single value (for single select)
        const savedValue = this.params.value;
        this.params.value = this.editDropdownOptionsArray.some((option) => option[this.editDropdownValueId] === savedValue)
          ? [ savedValue ]
          : [];
      }
    }
  }

  onSelectClose(): void {
    this.params.api.stopEditing();
  }
}
